import * as types from './actionTypes';
import api from '../../../api/';

export function getData() {
  // body...
  return async (dispatch, getState) => {
    dispatch({
      type: types.LOADING,
    });
    try {
      const cities = await api.getCities();
      const mostExplored = await api.getCityEateries();
      const localExperiences = await api.getLocalRecommends();
      const topRead = await api.getTSRecommends('EATERY');
      const topExperiences = await api.getExperiences();
      const bestNativeFood = await api.getNativeEateries();
      dispatch({
        type: types.LOADED,
        cities,
        mostExplored,
        localExperiences,
        topRead,
        bestNativeFood,
        topExperiences,
      });
    } catch (error) {
      console.log(error);
    }
  };
}
